import { createReducer } from "redux-act";
import { blockUi, unBlockUi } from './actions';
var defaultState = {
    isBlocked: false
};
var blockUiReducer = createReducer({}, defaultState).on(blockUi, function (state, payload) {
    return {
        isBlocked: true
    };
}).on(unBlockUi, function (state, payload) {
    return {
        isBlocked: false
    };
});
var BlockUiReducer = ({
    blockui: blockUiReducer
});
export default BlockUiReducer;



//////////////////
// WEBPACK FOOTER
// ./src/containers/BlockUi/ducks/index.ts
// module id = 688
// module chunks = 0